import { Quote } from "lucide-react";
import { TESTIMONIALS } from "@/data/content";
import { Reveal } from "@/components/Reveal";

export const Testimonials = () => {
  return (
    <section data-testid="testimonials-section" className="relative py-24 md:py-32 border-t border-stone-200 bg-[#F5F1EA]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <Reveal>
          <div className="text-xs uppercase tracking-[0.25em] text-[#B8860B] font-semibold mb-4 text-center">
            03 — Voices of our clients
          </div>
          <h2 className="font-display text-stone-900 text-4xl md:text-5xl lg:text-6xl font-light tracking-tighter text-center max-w-3xl mx-auto mb-16">
            What partners say<br />about working with us.
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-stone-200 border border-stone-200">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={i} delay={i * 100} className="bg-white p-8 lg:p-10" data-testid={`testimonial-${i}`}>
              <Quote className="w-8 h-8 text-[#B8860B] mb-6" strokeWidth={1} />
              <p className="text-stone-800 text-lg leading-relaxed mb-8 font-light">
                "{t.quote}"
              </p>
              <div className="pt-6 border-t border-stone-200">
                <div className="font-display text-stone-900">{t.author}</div>
                <div className="text-stone-500 text-sm">{t.company}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
